"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPERTY_TYPE = void 0;
var PROPERTY_TYPE;
(function (PROPERTY_TYPE) {
    PROPERTY_TYPE["FIELD_NAME"] = "property_type";
    PROPERTY_TYPE["APARTMENT"] = "apartment";
    PROPERTY_TYPE["HOUSE"] = "house";
    PROPERTY_TYPE["COMMERCIAL"] = "commercial";
    PROPERTY_TYPE["LAND"] = "land";
})(PROPERTY_TYPE = exports.PROPERTY_TYPE || (exports.PROPERTY_TYPE = {}));
